/**
 * Initialize all heroes on the document
 * Now only handles the video play button
 */
export default function heroInit() {
  const heroElements = document.querySelectorAll('.hero')

  heroElements.forEach(heroElement => {
    const video = heroElement.querySelector('video') as HTMLVideoElement
    if (video) {
      const toggle = heroElement.querySelector('.js-hero-video-play') as HTMLButtonElement
      let isVideoPlaying = !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);

      toggle.addEventListener('click', (e) => {
        e.preventDefault()
        if (isVideoPlaying) {
          video.pause()
        } else {
          video.play()
        }
        isVideoPlaying = !isVideoPlaying
        updateButton(toggle, isVideoPlaying)
      })

      video.addEventListener('ended', () => { isVideoPlaying = false; updateButton(toggle, isVideoPlaying) })

      if (window.innerWidth >= 976) {
        video.play()
        isVideoPlaying = true
        updateButton(toggle, isVideoPlaying)
      }
    }

    function updateButton(toggle:HTMLButtonElement, isVideoPlaying:Boolean) {
      if (isVideoPlaying) {
        toggle.querySelector('.icon--play').classList.add('hidden')
        toggle.querySelector('.icon--stop').classList.remove('hidden')
      } else {
        toggle.querySelector('.icon--play').classList.remove('hidden')
        toggle.querySelector('.icon--stop').classList.add('hidden')
      }
    }
  });
}
